import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import money from "./../assets/images/money.svg";
import mvolaGreen from "./../assets/images/mvolaGreen.svg";
import Modal from "react-modal";
import MODAL_STYLES from "./../assets/styles/modal";
import closeYellow from "./../assets/images/closeYellow.svg";
import checkGreen from "./../assets/images/checkGreen.svg";
import playstore from "./../assets/images/playStorev2.svg";
import appstore from "./../assets/images/appStorev2.svg";
import MoozikServices from "../services/http/MoozikServices";
import { useMsisdnContext } from "../context/MsisdnContext";
import { MoonLoader } from "react-spinners";

function Paye() {
  const navigate = useNavigate();
  const { msisdnBalance, msisdn } = useMsisdnContext();
  const { state } = useLocation();

  const [paymentType, setPaymentType] = useState("main_account");
  const choosePaymentType = (type) => {
    // console.log("type : ", type);
    setPaymentType(type);
  };
  const [isModalSucess, setIsModalSucess] = useState(false);
  const [isModalFailed, setIsModalFailed] = useState(false);
  const [loading, setLoading] = useState(false);

  const openModalPayment = useCallback(async () => {
    setLoading(true);
    try {
      const req = await MoozikServices.buyOffer({
        msisdn,
        payment_type: paymentType,
        rpid: state.rpid,
      });

      if (
        req &&
        (req.statuscode === 200 ||
          req.statuscode === "200" ||
          req.statuscode === "000" ||
          req.code === 200 ||
          req.code === "200")
      ) {
        setIsModalSucess(true);
      } else {
        setIsModalFailed(true);
      }
    } catch (error) {
      if (error?.code === 600) {
        console.log("timeout -----------------------------------");
      } else {
        console.log(
          "error -----------------------------------",
          JSON.stringify(error, null, 3),
        );
      }
      setIsModalFailed(true);
      // window.alert("buy: " + error.description || "Erreur non reconnue");
    } finally {
      setLoading(false);
    }
  }, [msisdn, paymentType, state.rpid]);

  function closeModal() {
    setIsModalSucess(false);
    setIsModalFailed(false);
  }

  const navigateToPlayStore = () => {
    const url =
      "https://play.google.com/store/apps/details?id=com.moozik.android";
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const navigateToAppStore = () => {
    const url =
      "https://apps.apple.com/mg/app/moozik-musique-et-karaok%C3%A9/id6503946864?l=fr-FR";
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const goToHome = () => {
    navigate("/");
  };

  return (
    <div className="relative h-[fit-content] z-3 w-[100%] bg-whitesmoke-300 rounded-sm">
      <div className="container p-6 w-auto">
        <div className="columns-2 w-[100%]">
          <div className="font-semibold text-black flex items-center justify-start">
            Montant à payer
          </div>
          <div className="text-xl font-extrabold text-black flex items-center justify-end">
            <div className="flex items-center justify-end text-[#00377D]">
              {state?.amount}
            </div>
            <div className="flex items-center justify-start">
              <span className="text-xs font-medium text-gold-200 ml-1 mb-1">
                Ar
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-start mt-2">
          <div className="container">
            <div
              key="main_account"
              className={`columns-2 h-9 text-xs pl-2 pr-4 mt-4 mb-3 flex items-center justify-between rounded-11xl box-border border-[1px] border-solid cursor-pointer ${
                paymentType === "main_account"
                  ? "bg-selectedBlue border-mainblue"
                  : "bg-whitesmoke-100 border-whitesmoke-400"
              }`}
              onClick={() => choosePaymentType("main_account")}
            >
              <div className="text-black h-[100%] flex items-center justify-start">
                <div className="h-[100%] flex items-center">
                  {paymentType === "main_account" ? (
                    <div className="rounded-[50%] bg-white box-border w-[23px] h-[23px] border-[1px] border-solid border-mainblue flex items-center justify-center">
                      <div className="rounded-[50%] bg-mainblue w-[15px] h-[15px]"></div>
                    </div>
                  ) : (
                    <div className="rounded-[50%] bg-white box-border w-[23px] h-[23px] border-[1px] border-solid border-gainsboro flex items-center justify-center"></div>
                  )}
                </div>
                <div className="ml-2 font-semibold flex items-center justify-start">{`Crédit disponible `}</div>
              </div>

              <div className="flex items-center justify-start h-[100%]">
                <img className="w-3 h-3 overflow-hidden" alt="" src={money} />
                <div className="flex items-center justify-center w-auto h-[100%]">
                  <div className="font-semibold text-black">
                    {msisdnBalance}
                  </div>
                  <div className="text-3xs font-medium text-lightslategray pl-1">
                    Ar
                  </div>
                </div>
              </div>
            </div>

            <div
              key="mvola"
              className={`columns-2 h-9 text-xs pl-2 pr-4 mt-3 mb-3 flex items-center justify-between rounded-11xl box-border border-[1px] border-solid 
                opacity-20
                ${"bg-whitesmoke-100 border-whitesmoke-400"}`}
              onClick={() => {}}
              // onClick={() => choosePaymentType("mvola")}
            >
              <div className="text-black h-[100%] flex items-center justify-start">
                <div className="h-[100%] flex items-center">
                  {paymentType === "mvola" ? (
                    <div className="rounded-[50%] bg-white box-border w-[23px] h-[23px] border-[1px] border-solid border-mainblue flex items-center justify-center">
                      <div className="rounded-[50%] bg-mainblue w-[15px] h-[15px]"></div>
                    </div>
                  ) : (
                    <div className="rounded-[50%] bg-white box-border w-[23px] h-[23px] border-[1px] border-solid border-gainsboro flex items-center justify-center"></div>
                  )}
                </div>
                <div className="ml-2 font-semibold flex items-center justify-start">{`Acheter avec mvola `}</div>
              </div>

              <div className="flex items-center justify-start h-[100%]">
                <img
                  className="w-4 h-4 overflow-hidden"
                  alt=""
                  src={mvolaGreen}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between w-[100%] mt-5">
          <div
            className="rounded-2xl box-border w-[45%] h-8 border-[1px] border-solid flex items-center justify-center cursor-pointer text-lightslategray border-lightslategray"
            onClick={loading ? undefined : goToHome}
          >
            <div className="uppercase font-semibold">Annuler</div>
          </div>

          <div
            className="rounded-2xl bg-mainblue [color:#FFD100] w-[45%] h-8 flex items-center justify-center cursor-pointer flex-row"
            onClick={loading ? undefined : openModalPayment}
          >
            <div className={`uppercase font-semibold flex-row`}>
              {loading ? <MoonLoader size={15} color="white" /> : "Acheter"}
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalSucess}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        style={MODAL_STYLES}
        contentLabel="Success payment"
        className="moozik-modal"
      >
        <img
          className="relative top-[-15px] left-[95%] w-6 h-6"
          alt=""
          src={closeYellow}
          onClick={closeModal}
        />

        <div className="relative top-[-15px] w-[auto] ml-4 mr-4 container font-montserrat">
          <div className="flex items-center justify-start">
            <b className="text-5xl leading-[135%] text-gray-200">
              Opération réussie
            </b>
          </div>
          <div className="flex flex-col items-start justify-start mt-2">
            {/* <div className="flex items-start justify-start mt-2 mb-2">
              <img className="w-[19px] h-[19px]" alt="" src={checkGreen} />
              <div className="ml-2">Votre compte Moozik a été crée.</div>
            </div> */}
            <div className="flex items-start justify-center mt-2 mb-2">
              <img className="w-[19px] h-[19px]" alt="" src={checkGreen} />
              <div className="ml-2">Achat offre effectué avec succès.</div>
            </div>
            {state.offername ? (
              <div className="flex items-start justify-center mt-2 mb-2">
                <img className="w-[19px] h-[19px]" alt="" src={checkGreen} />
                <div className="ml-2">
                  Vous profitez maintenant de l'offre {state.offername}.
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="flex items-start justify-center mt-2 mb-2">
              <b>Nb</b>
              <div className="ml-2">Télécharger l'application Moozik via</div>
            </div>
          </div>
          <div className="flex items-center justify-center mt-2">
            <img
              className="w-[145px] h-[45px] object-cover rounded z-20 cursor-pointer"
              alt=""
              src={playstore}
              onClick={() => navigateToPlayStore()}
            />
            <span className="ml-2 mr-2">Ou</span>
            <img
              className="w-[145px] h-[45px] object-cover rounded z-20 cursor-pointer"
              alt=""
              src={appstore}
              onClick={() => navigateToAppStore()}
            />
          </div>
          <div className="flex items-center justify-center mt-6">
            <div
              className="rounded-xl bg-gold-200 w-[50%] h-10 flex items-center justify-center cursor-pointer"
              onClick={closeModal}
            >
              <div className="font-semibold [color:#123274]">Fermer</div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-[10px] left-[0px] w-[100%] text-white text-3xs font-semibold opacity-[0.29] font-montserrat flex items-center justify-center">
          <span>Copyright DIGITAL TELMA 2023</span>
        </div>
      </Modal>

      <Modal
        isOpen={isModalFailed}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        style={MODAL_STYLES}
        contentLabel="Failed payment"
        className="moozik-modal"
      >
        <img
          className="relative top-[-15px] left-[95%] w-6 h-6"
          alt=""
          src={closeYellow}
          onClick={closeModal}
        />

        <div className="relative top-[-15px] w-[auto] ml-4 mr-4 container font-montserrat">
          <div className="flex items-center justify-center">
            <b className="text-5xl leading-[135%] text-red">
              Echec d'opération
            </b>
          </div>
          <div className="flex flex-col items-center justify-center mt-6">
            <div className="ml-2">
              Une erreur est survenue lors de l'achat. Veuillez réessayer ou
              vérifier votre compte.
            </div>
          </div>
          <div className="flex items-center justify-center mt-6">
            <div
              className="rounded-xl bg-mainblue w-[50%] h-10 flex items-center justify-center cursor-pointer"
              onClick={closeModal}
            >
              <div className="font-semibold text-gray-100">Fermer</div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-[10px] left-[0px] w-[100%] text-white text-3xs font-semibold opacity-[0.29] font-montserrat flex items-center justify-center">
          <span>Copyright DIGITAL TELMA 2023</span>
        </div>
      </Modal>
    </div>
  );
}

export default Paye;
